import { initialState } from '@chegg-wt/core/state/currentProject/reducer'
import { CurrentProjectState } from '@chegg-wt/core/state/currentProject/types'
import { NextRouter } from 'next/router'
import { GetFromQuery, IsExact } from '../types/core'
import { UserStyles } from './userStyles'

interface GetCurrentProjectPreloadedStateProps {
  getStyleFromQuery?: GetFromQuery
  isStyleExact?: IsExact
  router: NextRouter
  getActualStyleId?: (style: string) => string
}

type GetCurrentProjectPreloadedStateFn = (
  props: GetCurrentProjectPreloadedStateProps
) => CurrentProjectState

export const getCurrentProjectPreloadedState: GetCurrentProjectPreloadedStateFn = ({
  getStyleFromQuery = (_, styleQuery) => styleQuery,
  isStyleExact = () => true,
  router,
  getActualStyleId,
}) => {
  const { route, query } = router

  const { style: styleQuery } = query as {
    style: string
  }

  const urlStyle = getActualStyleId
    ? getActualStyleId(getStyleFromQuery(router, styleQuery, false))
    : getStyleFromQuery(router, styleQuery)
  const { defaultStyle: stateStyle } = initialState
  const styleIsExact = isStyleExact(route, styleQuery)

  // skip preloading state if url style is gated
  const userStyles = new UserStyles(null)
  const isStyleAllowed = userStyles.isStyleAllowed(urlStyle)

  const shouldUseUrlStyle = urlStyle && styleIsExact && isStyleAllowed
  const defaultStyle = shouldUseUrlStyle ? urlStyle : stateStyle
  return {
    ...initialState,
    defaultStyle,
  }
}
